export function authHeader() {
  // return authorization header with jwt token
  let token = JSON.parse(localStorage.getItem("accessToken"));
  let team = JSON.parse(localStorage.getItem("teamId"));
  return { Authorization: `Bearer ${token ? token : ""}`, Team: team, 'X-Device': 'WEB', };
}
